module.exports = __webpack_public_path__ + "img/icon_monthlyPass.d30a7db6.png";